import { useFormikContext } from "formik";
import React from "react";
import Field from "../Field";
import Button from "../Button";
import Loader from "../Loader";
import { CheckBox } from "../Input";
import { useFormContext } from "../../context/FormContext";

export default function SurveyFormContent({ fields, saveDraft, token, isDraftLoading }) {
  const { handleSubmit, isSubmitting, values, setSubmitting } = useFormikContext();
  const {merchant} = useFormContext();
  if (!fields || fields.length < 1) return <p>No survey questions found.</p>;

  // Filter fields based on type
  const displayFields = fields.filter((f) => f.field_type !== "file");
  const uploadFields = fields.filter((f) => f.field_type === "file");

  const handleContinueLater = async () => {
    const success = await saveDraft({values, token, is_submitted:false, formik: { setSubmitting }, merchantData: merchant });
  };

  return (
    <form onSubmit={handleSubmit} className="survey-form-layout">
      <div className="questions-list">
        {displayFields.map((field, index) => (
          <div key={`field-${index}`} className="question-item">
            <Field field={{...field, initialValue: values[field.field_label]}} isSurvey={true} />
          </div>
        ))}

        {uploadFields.length > 0 && (
          <div className="uploads-section">
            {uploadFields.map((field, index) => (
              <div key={`upload-${index}`} className="question-item">
                <Field field={field} />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="survey-attestation">
        <CheckBox
          field_items={[
            "I hereby consent to the collection, use, processing, and storage of my personal data for the purpose of delivering the requested government service(s).",
          ]}
          isRequired={true}
          field_label={"Attestation"}
        />
      </div>

      <div className="survey-actions">
        <Button
          type="button"
          className="btn-continue-later"
          onClick={handleContinueLater}
          disabled={isSubmitting || isDraftLoading}
        >
          {isDraftLoading ? (
            <>
              Saving...
              <Loader size="small" />
            </>
          ) : (
            "Continue Later"
          )}
        </Button>

        <Button type="submit" className="btn-submit-survey" disabled={isSubmitting || isDraftLoading}>
          {isSubmitting && !isDraftLoading ? (
            <>
              Submitting...
              <Loader size="small" />
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </div>
    </form>
  );
}
